import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/gastos/gastos';
import GastoGrid from './GastosGrid';

const mstp = state => {
    return {...state.gastos, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(GastoGrid)
